
import {defineComponent, PropType} from "vue";
import BaseAccordion from "@/components/UI/Bootstrap/Accordion/BaseAccordion.vue";
import BaseAccordionItem from "@/components/UI/Bootstrap/Accordion/BaseAccordionItem.vue";
import BaseAccordionHeader from "@/components/UI/Bootstrap/Accordion/BaseAccordionHeader.vue";
import BaseAccordionCollapse from "@/components/UI/Bootstrap/Accordion/BaseAccordionCollapse.vue";

export default defineComponent({
  name: "ExtraMetadataSection",
  components: {BaseAccordion, BaseAccordionItem, BaseAccordionHeader, BaseAccordionCollapse},
  props: {
    // Unique per form instance: the Bootstrap collapse is wired through element ids.
    id: {
      type: String,
      required: true,
    },
    // Titles of the groups that are currently switched on. Drives both the badge
    // count and the summary text, and whether the section starts folded open.
    activeLabels: {
      type: Array as PropType<string[]>,
      required: true,
    },
    // Optional lead-in for the summary, e.g. "Geavanceerde vormgeving".
    prefix: {
      type: String,
      required: false,
      default: null,
    },
  },
  data() {
    return {
      // Bootstrap drives the folding; this mirrors its state so the icon can follow.
      isOpen: this.activeLabels.length > 0 as boolean,
    };
  },
  mounted() {
    const collapseElement = document.getElementById(this.collapseId);

    if (collapseElement) {
      collapseElement.addEventListener('show.bs.collapse', this.onCollapseShow);
      collapseElement.addEventListener('hide.bs.collapse', this.onCollapseHide);
    }
  },
  beforeUnmount() {
    const collapseElement = document.getElementById(this.collapseId);

    if (collapseElement) {
      collapseElement.removeEventListener('show.bs.collapse', this.onCollapseShow);
      collapseElement.removeEventListener('hide.bs.collapse', this.onCollapseHide);
    }
  },
  methods: {
    onCollapseShow(): void {
      this.isOpen = true;
    },
    onCollapseHide(): void {
      this.isOpen = false;
    },
  },
  computed: {
    accordionId(): string {
      return `extra_metadata_${this.id}`;
    },
    headerId(): string {
      return `extra_metadata_header_${this.id}`;
    },
    collapseId(): string {
      return `extra_metadata_collapse_${this.id}`;
    },
    summary(): string {
      const state = this.activeLabels.length
        ? this.$t('cms.extraMetadataActive', {groups: this.activeLabels.join(', ')})
        : this.$t('cms.extraMetadataNoChanges');

      return this.prefix ? `${this.prefix} — ${state}` : state;
    },
  },
});
